import React, { useState, useEffect, Fragment, forwardRef, useImperativeHandle, useRef } from 'react';
import { get } from '../../Services/http';
import { translate } from '../../Services/translation';
import BuyButton from '../BuyButton';
import { useDispatch, useSelector } from 'react-redux';
import { setLensspecifications } from '../../Actions/LensSpecifications.actions';
import { lensspecificationconstants } from '../../lensspecificationconstants';
import Popup from '../AddToCartPopup';

const LensSpecification = forwardRef((props, _ref) => {
    const editInformation = props.recommendationToEdit ? props.recommendationToEdit : (props.subscriptionToEdit ? props.subscriptionToEdit : []);
    const [numberOfPackets, setnumberOfPackets] = useState(props.numberOfPackets);
    const [variantLensSpecifications, setVariantLensSpecifications] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleIsProcessing = async () => {
        setIsProcessing(true);
    };

    const handleBuyButtonClick = async () => {
        setShowPopup(true);
      };

    // Strength
    const [strengthOptions, setstrengthOptions] = useState([]);
    const [rightEyeStrength, setrightEyeStrength] = useState('');
    const [leftEyeStrength, setleftEyeStrength] = useState('');
    
    // Curve
    const [rightEyeCurveOptions, setRightEyeCurveOptions] = useState([]);
    const [leftEyeCurveOptions, setLeftEyeCurveOptions] = useState([]);
    const [rightEyeCurve, setrightEyeCurve] = useState('');
    const [leftEyeCurve, setleftEyeCurve] = useState('');
    
    // Diameter
    const [rightEyeDiameterOptions, setRightEyeDiameterOptions] = useState([]);
    const [leftDiameterOptions, setLeftDiameterOptions] = useState([]);
    const [rightEyeDiameter, setrightEyeDiameter] = useState('');
    const [leftEyeDiameter, setleftEyeDiameter] = useState('');
    
    // Cylinder
    const [hasCylinderOption, setHasCylinderOption] = useState(false);
    const [rightEyeCylinderOptions, setRightEyeCylinderOptions] = useState([]);
    const [leftEyeCylinderOptions, setleftCylinderOptions] = useState([]);
    const [rightEyeCylinder, setrightEyeCylinder] = useState('');
    const [leftEyeCylinder, setleftEyeCylinder] = useState('');
    
    // Axis
    const [hasAxisOption, setHasAxisOption] = useState(false);
    const [rightAxisOptions, setRightAxisOptions] = useState([]);
    const [leftAxisOptions, setLeftAxisOptions] = useState([]);
    const [rightEyeAxis, setrightEyeAxis] = useState('');
    const [leftEyeAxis, setleftEyeAxis] = useState('');
    
    // Add
    const [hasAddOption, setHasAddOption] = useState(false);
    const [rightAdditions, setRightEyeAdditions] = useState([]);
    const [leftAdditions, setLeftEyeAdditions] = useState([]);
    const [rightEyeAddOption, setrightEyeAddOption] = useState('');
    const [leftEyeAddOption, setleftEyeAddOption] = useState('');
    
    // Color
    const [hasColorOption, setHasColorOption] = useState(false);
    const [rightColors, setRightColorOptions] = useState([]);
    const [leftColors, setLeftColorOptions] = useState([]);
    const [rightcolor, setRightColor] = useState('');
    const [leftcolor, setLeftColor] = useState('');

    // Page functions
    const [rightEyePacket, setrightEyePacket] = useState('');
    const [leftEyePacket, setleftEyePacket] = useState('');
    const [copyToLeftEye, setCopyToLeftEye] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [loading, setLoading] = useState(true);
    
    //Tooltip toggle show 
    const [showStrength, setShowStrength] = useState(false);
    const [showCurve, setShowCurve] = useState(false);
    const [showDiameter, setShowDiameter] = useState(false);
    const [showCylinder, setShowCylinder] = useState(false);
    const [showAxis, setShowAxis] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [showColor, setShowColor] = useState(false);

    const [showStrengthLeft, setShowStrengthLeft] = useState(false);
    const [showCurveLeft, setShowCurveLeft] = useState(false);
    const [showDiameterLeft, setShowDiameterLeft] = useState(false);
    const [showCylinderLeft, setShowCylinderLeft] = useState(false);
    const [showAxisLeft, setShowAxisLeft] = useState(false);
    const [showAddLeft, setShowAddLeft] = useState(false);
    const [showColorLeft, setShowColorLeft] = useState(false);

    const tooltipStrengthRef = useRef(null);
    const tooltipCurveRef = useRef(null);
    const tooltipDiameterRef = useRef(null);
    const tooltipCylinderRef = useRef(null);
    const tooltipAxisRef = useRef(null);
    const tooltipAddRef = useRef(null);
    const tooltipColorRef = useRef(null);

    const tooltipStrengthRefLeft = useRef(null);
    const tooltipCurveRefLeft = useRef(null);
    const tooltipDiameterRefLeft = useRef(null);
    const tooltipCylinderRefLeft = useRef(null);
    const tooltipAxisRefLeft = useRef(null);
    const tooltipAddRefLeft = useRef(null);
    const tooltipColorRefLeft = useRef(null);

    const handleClickOutside = (event) => {
        if (tooltipStrengthRef.current && !tooltipStrengthRef.current.contains(event.target)) {
            setShowStrength(false);
        }
        if (tooltipCurveRef.current && !tooltipCurveRef.current.contains(event.target)) {
            setShowCurve(false);
        }
        if (tooltipDiameterRef.current && !tooltipDiameterRef.current.contains(event.target)) {
            setShowDiameter(false);
        }
        if (tooltipCylinderRef.current && !tooltipCylinderRef.current.contains(event.target)) {
            setShowCylinder(false);
        }
        if (tooltipAxisRef.current && !tooltipAxisRef.current.contains(event.target)) {
            setShowAxis(false);
        }
        if (tooltipAddRef.current && !tooltipAddRef.current.contains(event.target)) {
            setShowAdd(false);
        }
        if (tooltipColorRef.current && !tooltipColorRef.current.contains(event.target)) {
            setShowColor(false);
        }
        if (tooltipStrengthRefLeft.current && !tooltipStrengthRefLeft.current.contains(event.target)) {
            setShowStrengthLeft(false);
        }
        if (tooltipCurveRefLeft.current && !tooltipCurveRefLeft.current.contains(event.target)) {
            setShowCurveLeft(false);
        }
        if (tooltipDiameterRefLeft.current && !tooltipDiameterRefLeft.current.contains(event.target)) {
            setShowDiameterLeft(false);
        }
        if (tooltipCylinderRefLeft.current && !tooltipCylinderRefLeft.current.contains(event.target)) {
            setShowCylinderLeft(false);
        }
        if (tooltipAxisRefLeft.current && !tooltipAxisRefLeft.current.contains(event.target)) {
            setShowAxisLeft(false);
        }
        if (tooltipAddRefLeft.current && !tooltipAddRefLeft.current.contains(event.target)) {
            setShowAddLeft(false);
        }
        if (tooltipColorRefLeft.current && !tooltipColorRefLeft.current.contains(event.target)) {
            setShowColorLeft(false);
        }

    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const cart = useSelector((state) => state.cart);
    const error = cart.error;
    const dispatch = useDispatch();
    const retainedValues = props.loadFromState === true ? useSelector((state) => state.lensSpecifications.payload) : [];

    useEffect(() => {
        if (error && error.length > 0) {
            if (error.some(x => x === `${translate('coptikk.product.subscriptionforeyeexists')} - ${translate('coptikk.product.righteye')}`)) {                
                setrightEyePacket('');
            }
    
            if (error.some(x => x === `${translate('coptikk.product.subscriptionforeyeexists')} - ${translate('coptikk.product.lefteye')}`)) {                
                setleftEyePacket('');
            }
        }        
    }, [error]);
   

    useEffect(() => {
        setnumberOfPackets(props.numberOfPackets);
    }, [props.numberOfPackets])

    useEffect(() => {        
        setLoading(true);
        get(`/api/product/getlensspecificationforarticles?articleNumber=${props.currentVariantId}`)
            .then((response) => response.json())
            .then((result) => {
                setVariantLensSpecifications(result);
                setLoading(false);
            });

            if (editInformation && editInformation.articleNumber === props.currentVariantId) {
                const recommendationToEditInfo = editInformation;
                if (!props.hideRightEye) {
                    setrightEyeStrength(recommendationToEditInfo.strength);
                    setrightEyeCurve(recommendationToEditInfo.curve);
                    setrightEyeDiameter(recommendationToEditInfo.diameter);
                    if (recommendationToEditInfo.cylinder) {
                        setrightEyeCylinder(recommendationToEditInfo.cylinder);
                    }                    
                    if (recommendationToEditInfo.axis) {
                        setrightEyeAxis(recommendationToEditInfo.axis);
                    }                   
                    if (recommendationToEditInfo.add) {
                        setrightEyeAddOption(recommendationToEditInfo.add);
                    }             
                    if (recommendationToEditInfo.color) {
                        setRightColor(recommendationToEditInfo.color);    
                    }                    
                    setrightEyePacket(recommendationToEditInfo.packet);
                }

                if (!props.hideLeftEye) {
                    setleftEyeStrength(recommendationToEditInfo.strength);
                    setleftEyeCurve(recommendationToEditInfo.curve);
                    setleftEyeDiameter(recommendationToEditInfo.diameter);
                    if (recommendationToEditInfo.cylinder) {
                        setleftEyeCylinder(recommendationToEditInfo.cylinder);
                    }        
                    if (recommendationToEditInfo.axis) {
                        setleftEyeAxis(recommendationToEditInfo.axis);
                    }            
                    if (recommendationToEditInfo.add) {
                        setleftEyeAddOption(recommendationToEditInfo.add);
                    }            
                    if (recommendationToEditInfo.color) {
                        setLeftColor(recommendationToEditInfo.color); 
                    }                                                   
                    setleftEyePacket(recommendationToEditInfo.packet);                
                }
            }

            if (props.numberOfPackets && props.numberOfPackets.length > 0) {
                if (props.subscriptionSelected) {
                    if (props.subscriptionToEdit === null || props.subscriptionToEdit === undefined) {
                        const tempNumberOfPackets = props.numberOfPackets ? props.numberOfPackets.filter(x => x <= props.maximumNumberOfPackagesForSubscription) : {};
                        if (tempNumberOfPackets.indexOf(rightEyePacket) < 0) {
                            setrightEyePacket('');
                        }
                        if (tempNumberOfPackets.indexOf(leftEyePacket) < 0) {
                            setleftEyePacket('');
                        }
                        setnumberOfPackets(tempNumberOfPackets);
                    }                    
                }
                else {
                    setnumberOfPackets(props.numberOfPackets);
                }
            }   
    }, []);

    const updateState = (key, value) => {
        dispatch(setLensspecifications(key, value));
    }    

    useImperativeHandle(_ref, () => ({
        getLensSpecificationSelectedValues : () => {
            return {
                articleNumber: props.currentVariantId, rightEyeStrength, leftEyeStrength, rightEyeCurve, leftEyeCurve, 
                rightEyeDiameter,
                leftEyeDiameter,
                rightEyeCylinder,
                leftEyeCylinder,
                rightEyeAxis,
                leftEyeAxis,
                leftEyeAddOption,
                rightEyeAddOption,
                leftcolor,
                rightcolor,
                rightEyePacket,
                leftEyePacket,
                hasCylinderOption,
                hasAxisOption,
                hasAddOption,
                hasColorOption,
                rightEyeProductNumber: getProductNumber(true),
                leftEyeProductNumber: getProductNumber(false),  
                lensDurationCategory: props.lensDurationCategory,              
            }
        }
    }))

    const getProductNumber = (isRightEye) => {
        if (isRightEye) {
            let filteredData = variantLensSpecifications.filter(a => a.strength.toString() === rightEyeStrength.toString() 
            && a.curve.toString() === rightEyeCurve.toString() && a.diameter.toString() === rightEyeDiameter.toString());

            if (rightEyeCylinderOptions && rightEyeCylinderOptions.length > 0) {
                filteredData = filteredData.filter(b => b.cylinder.toString() === rightEyeCylinder.toString());
            }

            if (rightAxisOptions && rightAxisOptions.length > 0) {
                filteredData = filteredData.filter(b => b.axis.toString() === rightEyeAxis.toString());
            }

            if (rightAdditions && rightAdditions.length > 0) {
                filteredData = filteredData.filter(b => b.addition.toString() === rightEyeAddOption.toString());
            }

            if (rightColors && rightColors.length > 0) {
                filteredData = filteredData.filter(b => b.color.toString() === rightcolor.toString());
            }

            return filteredData && filteredData.length > 0 ? filteredData[0].productNumber : "";
        } else {
            let filteredData = variantLensSpecifications.filter(a => a.strength.toString() === leftEyeStrength.toString() 
            && a.curve.toString() === leftEyeCurve.toString() && a.diameter.toString() === leftEyeDiameter.toString());

            if (leftEyeCylinderOptions && leftEyeCylinderOptions.length > 0) {
                filteredData = filteredData.filter(b => b.cylinder.toString() === leftEyeCylinder.toString());
            }

            if (leftAxisOptions && leftAxisOptions.length > 0) {
                filteredData = filteredData.filter(b => b.axis.toString() === leftEyeAxis.toString());
            }

            if (leftAdditions && leftAdditions.length > 0) {
                filteredData = filteredData.filter(b => b.addition.toString() === leftEyeAddOption.toString());
            }

            if (leftColors && leftColors.length > 0) {
                filteredData = filteredData.filter(b => b.color.toString() === leftcolor.toString());
            }

            return filteredData && filteredData.length > 0 ? filteredData[0].productNumber : "";
        }
    }

    useEffect(() => {
        if (props.loadFromState === true) {
            if (variantLensSpecifications.some(a => a.strength.toString() === retainedValues.rightEyeStrength.toString()))  {
                setrightEyeStrength(retainedValues.rightEyeStrength);
                setrightEyeCurve(retainedValues.rightEyeCurve);
                setrightEyeDiameter(retainedValues.rightEyeDiameter);
                setrightEyeCylinder(retainedValues.rightEyeCylinder);
                setrightEyeAxis(retainedValues.rightEyeAxis);
                setrightEyeAddOption(retainedValues.rightEyeAdd);
                setRightColor(retainedValues.rightEyeColor);
                if (numberOfPackets.indexOf(retainedValues.rightEyePacket) > -1) {
                    setrightEyePacket(retainedValues.rightEyePacket);
                }                
            }
            
            if (variantLensSpecifications.some(a => a.strength.toString() === retainedValues.leftEyeStrength.toString())) {
                setleftEyeStrength(retainedValues.leftEyeStrength);
                setleftEyeCurve(retainedValues.leftEyeCurve);
                setleftEyeDiameter(retainedValues.leftEyeDiameter);
                setleftEyeCylinder(retainedValues.leftEyeCylinder);
                setleftEyeAxis(retainedValues.leftEyeAxis);
                setleftEyeAddOption(retainedValues.leftEyeAdd);
                setLeftColor(retainedValues.leftEyeColor);
                if (numberOfPackets.indexOf(retainedValues.leftEyePacket) > -1) {
                    setleftEyePacket(retainedValues.leftEyePacket);
                }                 
            }
        }                                  

    }, [variantLensSpecifications, props && props.loadFromState]);

    useEffect(() => {
        // Updates the render options when variant lensSpecification is fetched
        setHasCylinderOption(variantLensSpecifications.some((item) => item.cylinder !== null));
        setHasAxisOption(variantLensSpecifications.some((item) => item.axis !== null));
        setHasAddOption(variantLensSpecifications.some((item) => item.addition !== null));
        setHasColorOption(variantLensSpecifications.some((item) => item.color !== null));
    }, [variantLensSpecifications]);
    
    
    // Curve
    useEffect(() => {
        // Update curve options when strength changes
        if (rightEyeStrength !== '') {
            const filteredCurveOptions = [...new Set(variantLensSpecifications
                .filter((item) => item.strength?.toString() === rightEyeStrength?.toString())
                .map((item) => item.curve))];
            if (filteredCurveOptions && filteredCurveOptions.length === 1) {
                setrightEyeCurve(filteredCurveOptions[0]);
                updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Curve}`, filteredCurveOptions[0].toString());
            } else {
                if (editInformation && Object.keys(editInformation).length > 0 && !props.hideRightEye) {
                    setrightEyeCurve(editInformation.curve);
                }
                else if(!filteredCurveOptions.some(a => a.toString() === rightEyeCurve.toString())) {
                    retainedValues.rightEyeCurve ? setrightEyeCurve(retainedValues.rightEyeCurve) : setrightEyeCurve('');
                }                 
            }
            setRightEyeCurveOptions(filteredCurveOptions);
        } else {
            setRightEyeCurveOptions([]);
        }
        setCopyToLeftEye(false);
    }, [rightEyeStrength, variantLensSpecifications]);

    useEffect(() => {
        // Update curve options when strength changes
        if (leftEyeStrength !== '') {
            const filteredCurveOptions = [...new Set(variantLensSpecifications
                .filter((item) => item.strength?.toString() === leftEyeStrength?.toString())
                .map((item) => item.curve))];
            if (filteredCurveOptions && filteredCurveOptions.length === 1) {
                setleftEyeCurve(filteredCurveOptions[0]);
                updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Curve}`, filteredCurveOptions[0].toString());
            } else {
                if (editInformation && Object.keys(editInformation).length > 0 && !props.hideLeftEye) {
                    setleftEyeCurve(editInformation.curve);
                }
                else if(!filteredCurveOptions.some(a => a.toString() === leftEyeCurve.toString())) {
                    retainedValues.leftEyeCurve ?  setleftEyeCurve(retainedValues.leftEyeCurve) : setleftEyeCurve('');
                }                
            }
            setLeftEyeCurveOptions(filteredCurveOptions);
        } else {
            setLeftEyeCurveOptions([]);
        }
    }, [leftEyeStrength, variantLensSpecifications]);
    
    // Diameter
    useEffect(() => {
        // Update diameter options when strength and curve changes
        if (rightEyeCurve !== '') {
            const filteredDiameterOptions = [...new Set(variantLensSpecifications
                .filter((item) => item.strength?.toString() === rightEyeStrength?.toString())
                .filter((item) => item.curve?.toString() === rightEyeCurve?.toString())
                .map((item) => item.diameter))];
            if (filteredDiameterOptions && filteredDiameterOptions.length === 1) {
                setrightEyeDiameter(filteredDiameterOptions[0]);
                updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Diameter}`, filteredDiameterOptions[0].toString());
            } else {
                if (editInformation && Object.keys(editInformation).length > 0 && !props.hideRightEye) {
                    setrightEyeDiameter(editInformation.diameter);
                }
                else if(!filteredDiameterOptions.some(a => a.toString() === rightEyeDiameter.toString())) {
                    retainedValues.rightEyeDiameter ? setrightEyeDiameter(retainedValues.rightEyeDiameter) : setrightEyeDiameter('');
                }                
            }
            setRightEyeDiameterOptions(filteredDiameterOptions);
        } else {
            setRightEyeDiameterOptions([]);
        }
        setCopyToLeftEye(false);
    }, [rightEyeStrength, rightEyeCurve, variantLensSpecifications]);

    useEffect(() => {
        // Update diameter options when strength and curve changes
        if (leftEyeCurve !== '') {
            const filteredDiameterOptions = [...new Set(variantLensSpecifications
                .filter((item) => item.strength?.toString() === leftEyeStrength?.toString())
                .filter((item) => item.curve?.toString() === leftEyeCurve?.toString())
                .map((item) => item.diameter))];
            if (filteredDiameterOptions && filteredDiameterOptions.length === 1) {
                setleftEyeDiameter(filteredDiameterOptions[0]);
                updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Diameter}`, filteredDiameterOptions[0].toString());
            } else {
                if (editInformation && Object.keys(editInformation).length > 0 && !props.hideLeftEye) {
                    setleftEyeDiameter(editInformation.diameter);
                }
                else if(!filteredDiameterOptions.some(a => a.toString() === leftEyeDiameter.toString())) {
                    retainedValues.leftEyeDiameter ? setleftEyeDiameter(retainedValues.leftEyeDiameter) : setleftEyeDiameter('');
                }                
            }
            setLeftDiameterOptions(filteredDiameterOptions);
        } else {
            setLeftDiameterOptions([]);
        }
    }, [leftEyeStrength, leftEyeCurve, variantLensSpecifications]);
    
    // Cylinder
    useEffect(() => {
        // Update cylinder options based on strength, curve and diameter        
        if (hasCylinderOption) {
            if (rightEyeCurve !== '' && rightEyeDiameter !== '') {
                const filteredCylinderOptions = [...new Set(variantLensSpecifications
                    .filter((item) => item.strength?.toString() === rightEyeStrength?.toString())
                    .filter((item) => item.curve?.toString() === rightEyeCurve?.toString()) 
                    .filter((item) => item.diameter?.toString() === rightEyeDiameter?.toString())
                    .map((item) => item.cylinder))];
                if (filteredCylinderOptions && filteredCylinderOptions.length === 1) {
                    setrightEyeCylinder(filteredCylinderOptions[0]);
                    updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Cylinder}`, filteredCylinderOptions[0].toString());
                } else {
                    if (editInformation && Object.keys(editInformation).length > 0 && !props.hideRightEye) {
                        setrightEyeCylinder(editInformation.cylinder);
                    }
                    else if(!filteredCylinderOptions.some(a => a.toString() === rightEyeCylinder.toString())) {
                        retainedValues.rightEyeCylinder ? setrightEyeCylinder(retainedValues.rightEyeCylinder) : setrightEyeCylinder('');
                    }                    
                }
                setRightEyeCylinderOptions(filteredCylinderOptions);
            } else {
                setRightEyeCylinderOptions([]);
            }
            setCopyToLeftEye(false);
        }
    }, [rightEyeStrength, rightEyeCurve, rightEyeDiameter, variantLensSpecifications]);
    useEffect(() => {
        // Update cylinder options based on strength, curve and diameter
        if (hasCylinderOption) {
            if (leftEyeCurve !== '' && leftEyeDiameter !== '') {
                const filteredCylinderOptions = [...new Set(variantLensSpecifications
                    .filter((item) => item.strength?.toString() === leftEyeStrength?.toString())
                    .filter((item) => item.curve?.toString() === leftEyeCurve?.toString()) 
                    .filter((item) => item.diameter?.toString() === leftEyeDiameter?.toString())
                    .map((item) => item.cylinder))];
                if (filteredCylinderOptions && filteredCylinderOptions.length === 1) {
                    setleftEyeCylinder(filteredCylinderOptions[0]);
                    updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Cylinder}`, filteredCylinderOptions[0].toString());
                } else {
                    if (editInformation && Object.keys(editInformation).length > 0 && !props.hideLeftEye) {
                        setleftEyeCylinder(editInformation.cylinder);
                    }
                    else if(!filteredCylinderOptions.some(a => a.toString() === leftEyeCylinder.toString())) {
                        retainedValues.leftEyeCylinder ? setleftEyeCylinder(retainedValues.leftEyeCylinder) : setleftEyeCylinder('');
                    }                     
                }
                setleftCylinderOptions(filteredCylinderOptions);
            } else {
                setleftCylinderOptions([]);
            }
        }
    }, [leftEyeStrength, leftEyeCurve, leftEyeDiameter, variantLensSpecifications]);

    // Axis
    useEffect(() => {
        // Update axis options based on strength, curve, diameter and cylinder
        if (hasAxisOption) {
            if (rightEyeCurve !== '' && rightEyeDiameter !== '') {
                const filteredAxisOptions = [...new Set(variantLensSpecifications
                    .filter((item) => item.strength?.toString() === rightEyeStrength?.toString())
                    .filter((item) => item.curve?.toString() === rightEyeCurve?.toString())
                    .filter((item) => item.diameter?.toString() === rightEyeDiameter?.toString())
                    .filter((item) => item.cylinder?.toString() === rightEyeCylinder?.toString())
                    .map((item) => item.axis))];
                if (filteredAxisOptions && filteredAxisOptions.length === 1) {
                    setrightEyeAxis(filteredAxisOptions[0]);
                    updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Axis}`, filteredAxisOptions[0].toString());
                } else {
                    if (editInformation && Object.keys(editInformation).length > 0 && !props.hideRightEye) {
                        setrightEyeAxis(editInformation.axis);
                    }
                    else if(!filteredAxisOptions.some(a => a.toString() === rightEyeAxis.toString())) {
                        retainedValues.rightEyeAxis ?  setrightEyeAxis(retainedValues.rightEyeAxis) : setrightEyeAxis('');
                    }                    
                }
                setRightAxisOptions(filteredAxisOptions);
            } else {
                setRightAxisOptions([]);
            }
            setCopyToLeftEye(false);
        }
    }, [rightEyeStrength, rightEyeCurve, rightEyeDiameter, rightEyeCylinder, variantLensSpecifications]);
    useEffect(() => {
        // Update axis options based on strength, curve, diameter and cylinder
        if (hasAxisOption) {
            if (leftEyeCurve !== '' && leftEyeDiameter !== '') {
                const filteredAxisOptions = [...new Set(variantLensSpecifications
                    .filter((item) => item.strength?.toString() === leftEyeStrength?.toString())
                    .filter((item) => item.curve?.toString() === leftEyeCurve?.toString())
                    .filter((item) => item.diameter?.toString() === leftEyeDiameter?.toString())
                    .filter((item) => item.cylinder?.toString() === leftEyeCylinder?.toString())
                    .map((item) => item.axis))];
                if (filteredAxisOptions && filteredAxisOptions.length === 1) {
                    setleftEyeAxis(filteredAxisOptions[0]);
                    updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Axis}`, filteredAxisOptions[0].toString());
                } else {
                    if (editInformation && Object.keys(editInformation).length > 0 && !props.hideLeftEye) {
                        setleftEyeAxis(editInformation.axis);
                    }
                    else if(!filteredAxisOptions.some(a => a.toString() === leftEyeAxis.toString())) {
                        retainedValues.leftEyeAxis ?  setleftEyeAxis(retainedValues.leftEyeAxis) : setleftEyeAxis('');
                    }                    
                }
                setLeftAxisOptions(filteredAxisOptions);
            } else {
                setLeftAxisOptions([]);
            }
        }
    }, [leftEyeStrength, leftEyeCurve, leftEyeDiameter, leftEyeCylinder, variantLensSpecifications]);

    // Add
    useEffect(() => {
        // Update add options based on strength, curve, diameter, cylinder and axis
        if (hasAddOption) {
            if (rightEyeCurve !== '' && rightEyeDiameter !== '') {
                if (hasCylinderOption && hasAxisOption) {
                    const filteredAddOptions = [...new Set(variantLensSpecifications
                        .filter((item) => item.strength?.toString() === rightEyeStrength?.toString())
                        .filter((item) => item.curve?.toString() === rightEyeCurve?.toString())
                        .filter((item) => item.diameter?.toString() === rightEyeDiameter?.toString())
                        .filter((item) => item.cylinder?.toString() === rightEyeCylinder?.toString())
                        .filter((item) => item.axis?.toString() === rightEyeAxis?.toString())
                        .map((item) => item.addition))];
                    if (filteredAddOptions && filteredAddOptions.length === 1) {
                        setrightEyeAddOption(filteredAddOptions[0]);
                        updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Add}`, filteredAddOptions[0].toString());
                    } else {
                        if (editInformation && Object.keys(editInformation).length > 0 && !props.hideRightEye) {
                            setrightEyeAddOption(editInformation.add);
                        }
                        else if(!filteredAddOptions.some(a => a.toString() === rightEyeAddOption.toString())) {
                            retainedValues.rightEyeAdd ? setrightEyeAddOption(retainedValues.rightEyeAdd) : setrightEyeAddOption('');
                        }                        
                    }
                    setRightEyeAdditions(filteredAddOptions);
                } else {
                    const filteredAddOptions = [...new Set(variantLensSpecifications
                        .filter((item) => item.strength?.toString() === rightEyeStrength?.toString())
                        .filter((item) => item.curve?.toString() === rightEyeCurve?.toString())
                        .filter((item) => item.diameter?.toString() === rightEyeDiameter?.toString())
                        .map((item) => item.addition))];
                    if (filteredAddOptions && filteredAddOptions.length === 1) {
                        setrightEyeAddOption(filteredAddOptions[0]);
                        updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Add}`, filteredAddOptions[0].toString());
                    } else {
                        if (editInformation && Object.keys(editInformation).length > 0 && !props.hideRightEye) {
                            setrightEyeAddOption(editInformation.add);
                        }
                        else if(!filteredAddOptions.some(a => a.toString() === rightEyeAddOption.toString())) {
                            retainedValues.rightEyeAdd ? setrightEyeAddOption(retainedValues.rightEyeAdd) : setrightEyeAddOption('');
                        }                         
                    }
                    setRightEyeAdditions(filteredAddOptions);
                }
            } else {
                setRightEyeAdditions([]);
            }            
        }
        setCopyToLeftEye(false);
    }, [rightEyeStrength, rightEyeCurve, rightEyeDiameter, rightEyeCylinder, rightEyeAxis, variantLensSpecifications]);
    useEffect(() => {
        // Update add options based on strength, curve, diameter, cylinder and axis
        if (hasAddOption) {
            if (leftEyeCurve !== '' && leftEyeDiameter !== '') {
                if (hasCylinderOption && hasAxisOption) {
                    const filteredAddOptions = [...new Set(variantLensSpecifications
                        .filter((item) => item.strength?.toString() === leftEyeStrength?.toString())
                        .filter((item) => item.curve?.toString() === leftEyeCurve?.toString())
                        .filter((item) => item.diameter?.toString() === leftEyeDiameter?.toString())
                        .filter((item) => item.cylinder?.toString() === leftEyeCylinder?.toString())
                        .filter((item) => item.axis?.toString() === leftEyeAxis?.toString())
                        .map((item) => item.addition))];
                    if (filteredAddOptions && filteredAddOptions.length === 1) {
                        setleftEyeAddOption(filteredAddOptions[0]);
                        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Add}`, filteredAddOptions[0].toString());
                    } else {
                        if (editInformation && Object.keys(editInformation).length > 0 && !props.hideLeftEye) {
                            setleftEyeAddOption(editInformation.add);
                        }
                        else if(!filteredAddOptions.some(a => a.toString() === leftEyeAddOption.toString())) {
                            retainedValues.leftEyeAdd ?  setleftEyeAddOption(retainedValues.leftEyeAdd) : setleftEyeAddOption('');
                        }                        
                    }
                    setLeftEyeAdditions(filteredAddOptions);
                } else {
                    const filteredAddOptions = [...new Set(variantLensSpecifications
                        .filter((item) => item.strength?.toString() === leftEyeStrength?.toString())
                        .filter((item) => item.curve?.toString() === leftEyeCurve?.toString())
                        .filter((item) => item.diameter?.toString() === leftEyeDiameter?.toString())
                        .map((item) => item.addition))];
                    if (filteredAddOptions && filteredAddOptions.length === 1) {
                        setleftEyeAddOption(filteredAddOptions[0]);
                        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Add}`, filteredAddOptions[0].toString());
                    } else {
                        if (editInformation && Object.keys(editInformation).length > 0 && !props.hideLeftEye) {
                            setleftEyeAddOption(editInformation.add);
                        }
                        else if(!filteredAddOptions.some(a => a.toString() === leftEyeAddOption.toString())) {
                            retainedValues.leftEyeAdd ?  setleftEyeAddOption(retainedValues.leftEyeAdd) : setleftEyeAddOption('');
                        }
                    }
                    setLeftEyeAdditions(filteredAddOptions);
                }
            } else {
                setLeftEyeAdditions([]);
            }
        }
    }, [leftEyeStrength, leftEyeCurve, leftEyeDiameter, leftEyeCylinder, leftEyeAxis, variantLensSpecifications]);

    // Color
    useEffect(() => {
        // Update color options based on strength, curve and diameter
        if (hasColorOption) {
            if (rightEyeCurve !== '' && rightEyeDiameter !== '') {
                let conditionallyFilteredData = variantLensSpecifications
                    .filter((item) => item.strength?.toString() === rightEyeStrength?.toString())
                    .filter((item) => item.curve?.toString() === rightEyeCurve?.toString())
                    .filter((item) => item.diameter?.toString() === rightEyeDiameter?.toString());
                   
                if (rightEyeCylinderOptions && rightEyeCylinderOptions.length > 0 && rightEyeCylinder)     {
                    conditionallyFilteredData = conditionallyFilteredData
                    .filter((item) => item.cylinder?.toString() === rightEyeCylinder?.toString());
                }

                if (rightAxisOptions && rightAxisOptions.length > 0 && rightEyeAxis)     {
                    conditionallyFilteredData = conditionallyFilteredData
                    .filter((item) => item.axis?.toString() === rightEyeAxis?.toString());
                }

                if (rightAdditions && rightAdditions.length > 0 && rightEyeAddOption)     {
                    conditionallyFilteredData = conditionallyFilteredData
                    .filter((item) => item.addition?.toString() === rightEyeAddOption?.toString());
                }

                const filteredColorOptions = [...new Set(conditionallyFilteredData
                    .map((item) => item.color))];
                if (filteredColorOptions && filteredColorOptions.length === 1) {
                    setRightColor(filteredColorOptions[0]);
                    updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Color}`, filteredColorOptions[0].toString());
                } else {
                    if (editInformation && Object.keys(editInformation).length > 0 && !props.hideRightEye) {
                        setRightColor(editInformation.color);
                    }
                    else if(!filteredColorOptions.some(a => a.toString() === rightcolor.toString())) {
                        retainedValues.rightEyeColor ? setRightColor(retainedValues.rightEyeColor) : setRightColor('');
                    }                    
                }
                setRightColorOptions(filteredColorOptions);
            } else {
                setRightColorOptions([]);
            }            
        }
        setCopyToLeftEye(false);
    }, [rightEyeStrength, rightEyeCurve, rightEyeDiameter, rightEyeCylinder, rightEyeAxis, rightEyeAddOption, variantLensSpecifications]);
    useEffect(() => {
        // Update color options based on strength, curve and diameter
        if (hasColorOption) {
            if (leftEyeCurve !== '' && leftEyeDiameter !== '') {
                let conditionallyFilteredData = variantLensSpecifications
                .filter((item) => item.strength?.toString() === leftEyeStrength?.toString())
                .filter((item) => item.curve?.toString() === leftEyeCurve?.toString())
                .filter((item) => item.diameter?.toString() === leftEyeDiameter?.toString());

                if (leftEyeCylinderOptions && leftEyeCylinderOptions.length > 0 && leftEyeCylinder)     {
                    conditionallyFilteredData = conditionallyFilteredData
                    .filter((item) => item.cylinder?.toString() === leftEyeCylinder?.toString());
                }

                if (leftAxisOptions && leftAxisOptions.length > 0 && leftEyeAxis)     {
                    conditionallyFilteredData = conditionallyFilteredData
                    .filter((item) => item.axis?.toString() === leftEyeAxis?.toString());
                }

                if (leftAdditions && leftAdditions.length > 0 && leftEyeAddOption)     {
                    conditionallyFilteredData = conditionallyFilteredData
                    .filter((item) => item.addition?.toString() === leftEyeAddOption?.toString());
                }

                const filteredColorOptions = [...new Set(conditionallyFilteredData
                    .map((item) => item.color))];
                if (filteredColorOptions && filteredColorOptions.length === 1) {
                    setLeftColor(filteredColorOptions[0]);
                    updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Color}`, filteredColorOptions[0].toString());
                } else {
                    if (editInformation && Object.keys(editInformation).length > 0 && !props.hideLeftEye) {
                        setLeftColor(editInformation.color);
                    }
                    else if(!filteredColorOptions.some(a => a.toString() === leftcolor.toString())) {
                        retainedValues.leftEyeColor ? setLeftColor(retainedValues.leftEyeColor) : setLeftColor('');
                    }                    
                }
                setLeftColorOptions(filteredColorOptions);
            } else {
                setLeftColorOptions([]);
            }
        }
    }, [leftEyeStrength, leftEyeCurve, leftEyeDiameter, leftEyeCylinder, leftEyeAxis, leftEyeAddOption, variantLensSpecifications]);
    
    useEffect(() => {
        setstrengthOptions(
            Array.from(new Set(variantLensSpecifications.map((a) => a.strength)))
        );
    }, [variantLensSpecifications]);

    useEffect(() => {
        let price = 0;
        if (rightEyePacket && rightEyePacket !== '0') {
            price += parseFloat(props.basePrice) * parseFloat(rightEyePacket);
        }

        if (leftEyePacket && leftEyePacket !== '0') {
            price += parseFloat(props.basePrice) * parseFloat(leftEyePacket);
        }

        if (price > 0 && props.subscriptionSelected) {
            if (props.isSixMonthsDeliverySubscription) {
                price = price / 6;
            } else {
                price = price / 3; 
            }
        }
        setTotalPrice(price);

        if (props.hideRightEye && props.onNumberOfPacketsChange) {
            props.onNumberOfPacketsChange(leftEyePacket);
        }
        else if (props.hideLeftEye && props.onNumberOfPacketsChange) {
            props.onNumberOfPacketsChange(rightEyePacket);
        }
    }, [rightEyePacket, leftEyePacket, props.subscriptionSelected]);

    const copySelectionToLeftEye = () => {
        setleftEyeStrength(rightEyeStrength);
        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Strength}`, rightEyeStrength);
        setleftEyeCurve(rightEyeCurve);
        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Curve}`, rightEyeCurve);
        setleftEyeDiameter(rightEyeDiameter);
        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Diameter}`, rightEyeDiameter);
        setleftEyePacket(rightEyePacket);
        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Packet}`, rightEyePacket);
        setleftEyeCylinder(rightEyeCylinder);
        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Cylinder}`, rightEyeCylinder);
        setleftEyeAxis(rightEyeAxis);
        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Axis}`, rightEyeAxis);
        setleftEyeAddOption(rightEyeAddOption);
        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Add}`, rightEyeAddOption);
        setLeftColor(rightcolor);
        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Color}`, rightcolor);
        setCopyToLeftEye(true);
    };

    const setCorrectCssClass = () => {
        const { isAddingRecommendations, totalPrice, notAvailable } = props;
        let cssClass = props.cssClass;
    
        if (isProcessing || isAddingRecommendations || totalPrice <= 0 || notAvailable === 'True') {
          cssClass += ' disabled';
        }        
    
        return cssClass;
    };

    return (
        <Fragment>
            <div className="product-detail__variants-title">
                {translate('coptikk.product.yourprescription')}
            </div>
            <div className="row product-detail__variants-row">  
                {loading &&
                    <div className='overlay'>
                        <div className='loading-spinner'></div>
                    </div>             
                }  
                <div className="column small-6">
                    {!props.hideRightEye &&<div className="product-detail__column-title">
                        {translate('coptikk.product.righteye')}
                    </div>}
                    {!props.hideRightEye && <div className="row">
                        <div className="column small-6 product-detail__select-column">
                            {translate('coptikk.product.strength')}
                        </div>
                        <div className="column small-6 product-detail__select-column">
                            <div
                                className="tooltip"
                                title={translate('coptikk.tooltip.strength')}
                                onClick={() => setShowStrength(!showStrength)}
                            >
                                ?
                            </div>
                            {/* <p ref={tooltipStrengthRef} className={`tooltip-description ${showStrength ? 'show' : ''}`}>
                                {translate('coptikk.tooltip.strength')}
                            </p> */}
                            {strengthOptions.length === 1 ? (
                                <div
                                    className="product-detail__single-value"
                                    disabled
                                    onChange={(e) => setrightEyeStrength(e.target.value)}
                                >
                                    {strengthOptions[0]}
                                </div>
                            ) : (
                                <select onChange={(e) => {
                                    setrightEyeStrength(e.target.value);
                                    updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Strength}`, e.target.value.toString());
                                }} value={rightEyeStrength} defaultValue={rightEyeStrength === 0 ? '0' : ''}>
                                    <option value="" disabled>
                                        {translate('coptikk.general.select')}
                                    </option>
                                    {strengthOptions
                                        .filter((x) => x !== '' && x !== undefined && x !== null)
                                        .map((x) => (
                                            <option key={x} value={x}>
                                                {x > 0 ? '+' + x.toFixed(2) : x.toFixed(2)}
                                            </option>
                                        ))}
                                </select>
                            )}
                        </div>
                    </div>}
                    {!props.hideRightEye && <div className="row">
                        <div className="column small-6 product-detail__select-column">
                            {translate('coptikk.product.curve')}{' '}
                        </div>
                        <div className="column small-6 product-detail__select-column">
                            <div
                                className="tooltip"
                                title={translate('coptikk.tooltip.curve')}
                                onClick={() => setShowCurve(!showCurve)}
                            >
                                ?
                            </div>
                            {/* <p ref={tooltipCurveRef} className={`tooltip-description ${showCurve ? 'show' : ''}`}>
                                {translate('coptikk.tooltip.curve')}
                            </p> */}
                            {rightEyeCurveOptions.length === 1 ? (
                                <div
                                    className="product-detail__single-value"
                                    disabled
                                    onChange={(e) => setrightEyeCurve(e.target.value)}
                                >
                                    {rightEyeCurveOptions[0]}
                                </div>
                            ) : (
                                <select
                                    onChange={(e) => {
                                        setrightEyeCurve(e.target.value);
                                        updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Curve}`, e.target.value.toString());
                                    }}
                                    value={rightEyeCurve}
                                >
                                    <option value="0">
                                        {translate('coptikk.general.select')}
                                    </option>
                                    {rightEyeCurveOptions
                                        .filter((x) => x !== '' && x !== undefined && x !== null)
                                        .map((x) => (
                                            <option key={x} value={x}>
                                                {x}
                                            </option>
                                        ))}
                                </select>
                            )}
                        </div>
                    </div>}
                    {!props.hideRightEye && <div className="row">
                        <div className="column small-6 product-detail__select-column">
                            {translate('coptikk.product.diameter')}{' '}
                        </div>
                        <div className="column small-6 product-detail__select-column">
                            <div
                                className="tooltip"
                                title={translate('coptikk.tooltip.diameter')}
                                onClick={() => setShowDiameter(!showDiameter)}
                            >
                                ?
                            </div>
                            {/* <p ref={tooltipDiameterRef} className={`tooltip-description ${showDiameter ? 'show' : ''}`}>
                                {translate('coptikk.tooltip.diameter')}
                            </p> */}
                            {rightEyeDiameterOptions.length === 1 ? (
                                <div
                                    className="product-detail__single-value"
                                    disabled
                                    onChange={(e) => {
                                        setrightEyeDiameter(e.target.value);
                                        updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Diameter}`, e.target.value.toString());
                                    }}
                                >
                                    {rightEyeDiameterOptions[0]}
                                </div>
                            ) : (
                                <select
                                    onChange={(e) => setrightEyeDiameter(e.target.value)}
                                    value={rightEyeDiameter}
                                >
                                    <option value="0">
                                        {translate('coptikk.general.select')}
                                    </option>
                                    {rightEyeDiameterOptions
                                        .filter((x) => x !== '' && x !== undefined && x !== null)
                                        .map((x) => (
                                            <option key={x} value={x}>
                                                {x}
                                            </option>
                                        ))}
                                </select>
                            )}

                        </div>
                    </div>}
                    {!props.hideRightEye && hasCylinderOption === true && (
                        <div className="row">
                            <div className="column small-6 product-detail__select-column">
                                {translate('coptikk.product.cylinder')}{' '}
                            </div>
                            <div className="column small-6 product-detail__select-column">
                                <div
                                    className="tooltip"
                                    title={translate('coptikk.tooltip.cylinder')}
                                    onClick={() => setShowCylinder(!showCylinder)}
                                >
                                    ?
                                </div>
                                {/* <p ref={tooltipCylinderRef} className={`tooltip-description ${showCylinder ? 'show' : ''}`}>
                                    {translate('coptikk.tooltip.cylinder')}
                                </p> */}
                                {rightEyeCylinderOptions.length === 1 ? (
                                    <div
                                        className="product-detail__single-value"
                                        disabled
                                        onChange={(e) => setrightEyeCylinder(e.target.value)}
                                    >
                                        {rightEyeCylinderOptions[0]}
                                    </div>
                                ) : (
                                    <select
                                        onChange={(e) => {
                                            setrightEyeCylinder(e.target.value);
                                            updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Cylinder}`, e.target.value.toString());
                                        }}
                                        value={rightEyeCylinder}
                                    >
                                        <option value="0">
                                            {translate('coptikk.general.select')}
                                        </option>
                                        {rightEyeCylinderOptions
                                            .filter((x) => x !== '' && x !== undefined && x !== null)
                                            .map((x) => (
                                                <option key={x} value={x}>
                                                    {x}
                                                </option>
                                            ))}
                                    </select>
                                )}
                            </div>
                        </div>)}
                    {!props.hideRightEye && hasAxisOption === true && (
                        <div className="row">
                            <div className="column small-6 product-detail__select-column">
                                {translate('coptikk.product.axis')}{' '}
                            </div>
                            <div className="column small-6 product-detail__select-column">
                                <div
                                    className="tooltip"
                                    title={translate('coptikk.tooltip.axis')}
                                    onClick={() => setShowAxis(!showAxis)}
                                >
                                    ?
                                </div>
                                {/* <p ref={tooltipAxisRef} className={`tooltip-description ${showAxis ? 'show' : ''}`}>
                                    {translate('coptikk.tooltip.axis')}
                                </p> */}
                                {rightAxisOptions.length === 1 ? (
                                    <div
                                        className="product-detail__single-value"
                                        disabled
                                        onChange={(e) => setrightEyeAxis(e.target.value)}
                                    >
                                        {rightAxisOptions[0]}
                                    </div>
                                ) : (
                                    <select
                                        onChange={(e) => {
                                            setrightEyeAxis(e.target.value);
                                            updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Axis}`, e.target.value.toString());
                                        }}
                                        value={rightEyeAxis}
                                    >
                                        <option value="0">
                                            {translate('coptikk.general.select')}
                                        </option>
                                        {rightAxisOptions
                                            .filter((x) => x !== '' && x !== undefined && x !== null)
                                            .map((x) => (
                                                <option key={x} value={x}>
                                                    {x}
                                                </option>
                                            ))}
                                    </select>
                                )}
                            </div>
                        </div>)}
                    {!props.hideRightEye && hasAddOption === true && (
                        <div className="row">
                            <div className="column small-6 product-detail__select-column">
                                {translate('coptikk.product.addfield')}{' '}
                            </div>
                            <div className="column small-6 product-detail__select-column">
                                <div
                                    className="tooltip"
                                    title={translate('coptikk.tooltip.add')}
                                    onClick={() => setShowAdd(!showAdd)}
                                >
                                    ?
                                </div>
                                {/* <p ref={tooltipAddRef} className={`tooltip-description ${showAdd ? 'show' : ''}`}>
                                    {translate('coptikk.tooltip.add')}
                                </p> */}
                                {rightAdditions.length === 1 ? (
                                    <div
                                        className="product-detail__single-value"
                                        disabled
                                        onChange={(e) => setrightEyeAddOption(e.target.value)}
                                    >
                                        {rightAdditions[0]}
                                    </div>
                                ) : (
                                    <select
                                        onChange={(e) => {
                                            setrightEyeAddOption(e.target.value);
                                            updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Add}`, e.target.value.toString());
                                            setCopyToLeftEye(false);
                                        }}
                                        value={rightEyeAddOption}
                                    >
                                        <option value="0">
                                            {translate('coptikk.general.select')}
                                        </option>
                                        {rightAdditions
                                            .filter((x) => x !== '' && x !== undefined && x !== null)
                                            .map((x) => (
                                                <option key={x} value={x}>{x}</option>
                                            ))}
                                    </select>
                                    )}
                            </div>
                        </div>
                    )}
                    {!props.hideRightEye && hasColorOption === true && (
                        <div className="row">
                            <div className="column small-6 product-detail__select-column">
                                {translate('coptikk.product.color')}{' '}
                            </div>
                            <div className="column small-6 product-detail__select-column">
                                <div
                                    className="tooltip"
                                    title={translate('coptikk.tooltip.color')}
                                    onClick={() => setShowColor(!showColor)}
                                >
                                    ?
                                </div>
                                {/* <p ref={tooltipColorRef} className={`tooltip-description ${showColor ? 'show' : ''}`}>
                                    {translate('coptikk.tooltip.color')}
                                </p> */}
                                {rightColors.length === 1 ? (
                                    <div
                                        className="product-detail__single-value"
                                        disabled
                                        onChange={(e) => setRightColor(e.target.value)}
                                    >
                                        {rightColors[0]}
                                    </div>
                                ) : (
                                    <select
                                        onChange={(e) => {
                                            setRightColor(e.target.value);
                                            updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Color}`, e.target.value.toString());
                                            setCopyToLeftEye(false);
                                        }}
                                        value={rightcolor}
                                    >
                                        <option value="0">
                                            {translate('coptikk.general.select')}
                                        </option>
                                        {rightColors
                                            .filter((x) => x !== '' && x !== undefined && x !== null)
                                            .map((x) => (
                                                <option key={x} value={x}>{x}</option>
                                            ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    )}            
                    {!props.hideRightEye && <div className="row">
                        <div className="column small-6 product-detail__select-column package-text">
                            {translate('coptikk.product.packets')}{' '}
                            {props.subscriptionSelected ? (props.isSixMonthsDeliverySubscription ? 
                            translate("coptikk.product.subscription.deliveredoversixmonthstext") :
                            translate("coptikk.product.subscription.deliveredoverthreemonthstext")) : ''}
                        </div>
                        <div className="column small-6 product-detail__select-column package">
                            <select
                                onChange={(e) => {
                                    setrightEyePacket(e.target.value);
                                    updateState(`${lensspecificationconstants.RightEyeText}${lensspecificationconstants.Packet}`, e.target.value.toString());
                                    setCopyToLeftEye(false);
                                }}
                                value={rightEyePacket}
                            >
                                <option value="0">{translate('coptikk.general.select')}</option>
                                {numberOfPackets && numberOfPackets
                                    .filter((x) => x !== '' && x !== undefined && x !== null)
                                    .map((x) => (
                                        <option key={x} value={x}>{x}</option>
                                    ))}
                                {numberOfPackets && rightEyePacket !== "" && numberOfPackets.indexOf(rightEyePacket) < 0 && 
                                <option hidden key={rightEyePacket} value={rightEyePacket}>{rightEyePacket}</option>}
                            </select>
                        </div>
                    </div>}
                    {!props.hideRightEye && !props.hideLeftEye && rightEyeDiameter && (
                        <div className="row">
                            <div className="column small-12 product-detail__copy-select">
                                <input
                                    type="radio"
                                    checked={copyToLeftEye}
                                    onClick={copySelectionToLeftEye}
                                ></input>
                                {translate('coptikk.product.copytolefteye')}
                            </div>
                        </div>
                    )}
                </div>



                {!props.hideLeftEye && 
                <div className="column small-6 product-detail__left-eye-column">
                    <div className="product-detail__column-title">
                        {translate('coptikk.product.lefteye')}
                    </div>
                    <div className="row">
                        <div className="column small-6 product-detail__select-column">
                            {translate('coptikk.product.strength')}
                        </div>
                        <div className="column small-6 product-detail__select-column">
                            <div
                                className="tooltip"
                                title={translate('coptikk.tooltip.strength')}
                                onClick={() => setShowStrengthLeft(!showStrengthLeft)}
                            >
                                ?
                            </div>
                            {/* <p ref={tooltipStrengthRefLeft} className={`tooltip-description ${showStrengthLeft ? 'show' : ''}`}>
                                {translate('coptikk.tooltip.strength')}
                            </p> */}
                            {strengthOptions.length === 1 ? (
                                <div
                                    className="product-detail__single-value"
                                    disabled
                                    onChange={(e) => setleftEyeStrength(e.target.value)}
                                >
                                    {strengthOptions[0]}
                                </div>
                            ) : (
                                <select onChange={(e) => {
                                    setleftEyeStrength(e.target.value);
                                    updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Strength}`, e.target.value.toString());
                                }} value={leftEyeStrength}>
                                    <option value="" disabled>
                                        {translate('coptikk.general.select')}
                                    </option>
                                    {strengthOptions
                                        .filter((x) => x !== '' && x !== undefined && x !== null)
                                        .map((x) => (
                                            <option key={x} value={x}>
                                                {x > 0 ? '+' + x.toFixed(2) : x.toFixed(2)}
                                            </option>
                                        ))}
                                </select>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="column small-6 product-detail__select-column">
                            {translate('coptikk.product.curve')}{' '}
                        </div>
                        <div className="column small-6 product-detail__select-column">
                            <div
                                className="tooltip"
                                title={translate('coptikk.tooltip.curve')}
                                onClick={() => setShowCurveLeft(!showCurveLeft)}
                            >
                                ?
                            </div>
                            {/* <p ref={tooltipCurveRefLeft} className={`tooltip-description ${showCurveLeft ? 'show' : ''}`}>
                                {translate('coptikk.tooltip.curve')}
                            </p> */}
                            {leftEyeCurveOptions.length === 1 ? (
                                <div
                                    className="product-detail__single-value"
                                    disabled
                                    onChange={(e) => setleftEyeCurve(e.target.value)}
                                >
                                    {leftEyeCurveOptions[0]}
                                </div>
                            ) : (
                                <select
                                    onChange={(e) => {
                                        setleftEyeCurve(e.target.value);
                                        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Curve}`, e.target.value.toString());
                                    }}
                                    value={leftEyeCurve}
                                >
                                    <option value="0">
                                        {translate('coptikk.general.select')}
                                    </option>
                                    {leftEyeCurveOptions
                                        .filter((x) => x !== '' && x !== undefined && x !== null)
                                        .map((x) => (
                                            <option key={x} value={x}>
                                                {x}
                                            </option>
                                        ))}
                                </select>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="column small-6 product-detail__select-column">
                            {translate('coptikk.product.diameter')}{' '}
                        </div>
                        <div className="column small-6 product-detail__select-column">
                            <div
                                className="tooltip"
                                title={translate('coptikk.tooltip.diameter')}
                                onClick={() => setShowDiameterLeft(!showDiameterLeft)}
                            >
                                ?
                            </div>
                            {/* <p ref={tooltipDiameterRefLeft} className={`tooltip-description ${showDiameterLeft ? 'show' : ''}`}>
                                {translate('coptikk.tooltip.diameter')}
                            </p> */}
                            {leftDiameterOptions.length === 1 ? (
                                <div
                                    className="product-detail__single-value"
                                    disabled
                                    onChange={(e) => setleftEyeDiameter(e.target.value)}
                                >
                                    {leftDiameterOptions[0]}
                                </div>
                            ) : (
                                <select
                                    onChange={(e) => {
                                        setleftEyeDiameter(e.target.value);
                                        updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Diameter}`, e.target.value.toString());
                                    }}
                                    value={leftEyeDiameter}
                                >
                                    <option value="0">
                                        {translate('coptikk.general.select')}
                                    </option>
                                    {leftDiameterOptions
                                        .filter((x) => x !== '' && x !== undefined && x !== null)
                                        .map((x) => (
                                            <option key={x} value={x}>
                                                {x}
                                            </option>
                                        ))}
                                </select>
                            )}
                        </div>
                    </div>
                    {hasCylinderOption === true && (
                        <div className="row">
                            <div className="column small-6 product-detail__select-column">
                                {translate('coptikk.product.cylinder')}{' '}
                            </div>
                            <div className="column small-6 product-detail__select-column">
                                <div
                                    className="tooltip"
                                    title={translate('coptikk.tooltip.cylinder')}
                                    onClick={() => setShowCylinderLeft(!showCylinderLeft)}
                                >
                                    ?
                                </div>
                                {/* <p ref={tooltipCylinderRefLeft} className={`tooltip-description ${showCylinderLeft ? 'show' : ''}`}>
                                    {translate('coptikk.tooltip.cylinder')}
                                </p> */}
                                {leftEyeCylinderOptions.length === 1 ? (
                                    <div
                                        className="product-detail__single-value"
                                        disabled
                                        onChange={(e) => setleftEyeCylinder(e.target.value)}
                                    >
                                        {leftEyeCylinderOptions[0]}
                                    </div>
                                ) : (

                                    <select
                                        onChange={(e) => {
                                            setleftEyeCylinder(e.target.value);
                                            updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Cylinder}`, e.target.value.toString());
                                        }}
                                        value={leftEyeCylinder}
                                    >
                                        <option value="0">
                                            {translate('coptikk.general.select')}
                                        </option>
                                        {leftEyeCylinderOptions
                                            .filter((x) => x !== '0' && x !== undefined && x !== null)
                                            .map((x) => (
                                                <option key={x} value={x}>
                                                    {x}
                                                </option>
                                            ))}
                                    </select>
                                )}
                            </div>
                        </div>)}
                    {hasAxisOption === true && (
                        <div className="row">
                            <div className="column small-6 product-detail__select-column">
                                {translate('coptikk.product.axis')}{' '}
                            </div>
                            <div className="column small-6 product-detail__select-column">
                                <div
                                    className="tooltip"
                                    title={translate('coptikk.tooltip.axis')}
                                    onClick={() => setShowAxisLeft(!showAxisLeft)}
                                >
                                    ?
                                </div>
                                {/* <p ref={tooltipAxisRefLeft} className={`tooltip-description ${showAxisLeft ? 'show' : ''}`}>
                                    {translate('coptikk.tooltip.axis')}
                                </p> */}
                                {leftAxisOptions.length === 1 ? (
                                    <div
                                        className="product-detail__single-value"
                                        disabled
                                        onChange={(e) => setleftEyeAxis(e.target.value)}
                                    >
                                        {leftAxisOptions[0]}
                                    </div>
                                ) : (
                                    <select
                                        onChange={(e) => {
                                            setleftEyeAxis(e.target.value);
                                            updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Axis}`, e.target.value.toString());
                                        }}
                                        value={leftEyeAxis}
                                    >
                                        <option value="0">
                                            {translate('coptikk.general.select')}
                                        </option>
                                        {leftAxisOptions
                                            .filter((x) => x !== '' && x !== undefined && x !== null)
                                            .map((x) => (
                                                <option key={x} value={x}>
                                                    {x}
                                                </option>
                                            ))}
                                    </select>
                                )}
                            </div>
                        </div>)}
                    {hasAddOption === true && (
                        <div className="row">
                            <div className="column small-6 product-detail__select-column">
                                {translate('coptikk.product.addfield')}{' '}
                            </div>
                            <div className="column small-6 product-detail__select-column">
                                <div
                                    className="tooltip"
                                    title={translate('coptikk.tooltip.add')}
                                    onClick={() => setShowAddLeft(!showAddLeft)}
                                >
                                    ?
                                </div>
                                {/* <p ref={tooltipAddRefLeft} className={`tooltip-description ${showAddLeft ? 'show' : ''}`}>
                                    {translate('coptikk.tooltip.add')}
                                </p> */}
                                {leftAdditions.length === 1 ? (
                                    <div
                                        className="product-detail__single-value"
                                        disabled
                                        onChange={(e) => setleftEyeAddOption(e.target.value)}
                                    >
                                        {leftAdditions[0]}
                                    </div>
                                ) : (
                                    <select
                                        onChange={(e) => {
                                            setleftEyeAddOption(e.target.value);
                                            updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Add}`, e.target.value.toString());
                                        }}
                                        value={leftEyeAddOption}
                                    >
                                        <option value="0">
                                            {translate('coptikk.general.select')}
                                        </option>
                                        {leftAdditions
                                            .filter((x) => x !== '' && x !== undefined && x !== null)
                                            .map((x) => (
                                                <option key={x} value={x}>{x}</option>
                                            ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    )}
                    {hasColorOption === true && (
                        <div className="row">
                            <div className="column small-6 product-detail__select-column">
                                {translate('coptikk.product.color')}{' '}
                            </div>
                            <div className="column small-6 product-detail__select-column">
                                <div
                                    className="tooltip"
                                    title={translate('coptikk.tooltip.color')}
                                    onClick={() => setShowColorLeft(!showColorLeft)}
                                >
                                    ?
                                </div>
                                {/* <p ref={tooltipColorRefLeft} className={`tooltip-description ${showColorLeft ? 'show' : ''}`}>
                                    {translate('coptikk.tooltip.color')}
                                </p> */}
                                {leftColors.length === 1 ? (
                                    <div
                                        className="product-detail__single-value"
                                        disabled
                                        onChange={(e) => setLeftColor(e.target.value)}
                                    >
                                        {leftColors[0]}
                                    </div>
                                ) : (
                                    <select
                                        onChange={(e) => {
                                            setLeftColor(e.target.value);
                                            updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Color}`, e.target.value.toString());
                                        }}
                                        value={leftcolor}
                                    >
                                        <option value="0">
                                            {translate('coptikk.general.select')}
                                        </option>
                                        {leftColors
                                            .filter((x) => x !== '' && x !== undefined && x !== null)
                                            .map((x) => (
                                                <option key={x} value={x}>{x}</option>
                                            ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="column small-6 product-detail__select-column package-text">
                            {translate('coptikk.product.packets')}{' '}
                            {props.subscriptionSelected ? (props.isSixMonthsDeliverySubscription ? 
                            translate("coptikk.product.subscription.deliveredoversixmonthstext") :
                            translate("coptikk.product.subscription.deliveredoverthreemonthstext")) : ''}
                        </div>
                        <div className="column small-6 product-detail__select-column package">
                            <select
                                onChange={(e) => {
                                    setleftEyePacket(e.target.value);
                                    updateState(`${lensspecificationconstants.LeftEyeText}${lensspecificationconstants.Packet}`, e.target.value.toString());
                                }}
                                value={leftEyePacket}
                            >
                                <option value="0">{translate('coptikk.general.select')}</option>
                                {numberOfPackets && numberOfPackets
                                    .filter((x) => x !== '' && x !== undefined && x !== null)
                                    .map((x) => (
                                        <option key={x} value={x}>{x}</option>
                                    ))}
                                {numberOfPackets && leftEyePacket && numberOfPackets.indexOf(leftEyePacket) < 0 && 
                                <option hidden key={leftEyePacket} value={leftEyePacket} disabled={true}>{leftEyePacket}</option>}    
                            </select>
                        </div>
                    </div>
                </div>}
            </div>
            <div className="product-detail__error">
                {error &&
                    error.map((x) => {
                        return <div>{x}</div>;
                    })}
            </div>            

            {!props.isAddingRecommendations && <div className="row product-detail__total-price">
                <div className='total'>{translate('coptikk.product.totalprice')} 
                    {props.subscriptionSelected ? 
                    <p className='per-month'>{translate("coptikk.product.subscription.permonthtext")}</p>
                        : ":"}
                </div>
                <div>
                    {totalPrice > 0 ? (
                        props.subscriptionSelected ? (
                        totalPrice.toLocaleString("nb-NO", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
                            .replace(/,00$/, ",-")
                        ) : (
                        totalPrice + ",-"
                        )
                    ) : (
                        "0,-"
                    )}
                </div>
            </div>}
            {!props.isAddingRecommendations && showPopup && 
                <Popup 
                    product={props} 
                    checkoutUrl={props.checkoutUrl}
                    onClose={() => setShowPopup(false)} 
                    rightStrength={rightEyeStrength}
                    leftStrength={leftEyeStrength}
                    rightCurve={rightEyeCurve}
                    leftCurve={leftEyeCurve}
                    rightDiameter={rightEyeDiameter}
                    leftDiameter={leftEyeDiameter}
                    rightCylinder={rightEyeCylinder}
                    leftCylinder={leftEyeCylinder}
                    rightAxis={rightEyeAxis}
                    leftAxis={leftEyeAxis}
                    leftEyeAdd={leftEyeAddOption}
                    rightEyeAdd={rightEyeAddOption}
                    leftColor={leftcolor}
                    rightColor={rightcolor}
                    rightPacket={rightEyePacket}
                    leftPacket={leftEyePacket}
                    subscription={props.subscriptionSelected}
                />
            }
            {!props.isAddingRecommendations && <BuyButton
                handleBuyButtonClick={handleBuyButtonClick} 
                handleIsProcessing={handleIsProcessing}
                setIsProcessing={setIsProcessing}
                label={props.label}
                articleNumber={props.articleNumber}
                quantityFieldId={props.quantityFieldId}
                href={props.href}
                cssClass={setCorrectCssClass()} 
                rightStrength={rightEyeStrength}
                leftStrength={leftEyeStrength}
                rightCurve={rightEyeCurve}
                leftCurve={leftEyeCurve}
                rightDiameter={rightEyeDiameter}
                leftDiameter={leftEyeDiameter}
                rightCylinder={rightEyeCylinder}
                leftCylinder={leftEyeCylinder}
                rightAxis={rightEyeAxis}
                leftAxis={leftEyeAxis}
                leftEyeAdd={leftEyeAddOption}
                rightEyeAdd={rightEyeAddOption}
                leftColor={leftcolor}
                rightColor={rightcolor}
                rightPacket={rightEyePacket}
                leftPacket={leftEyePacket}
                
                rightCylinderHasOptions={hasCylinderOption && rightEyeCylinderOptions.length > 0}
                leftCylinderHasOptions={hasCylinderOption && leftEyeCylinderOptions.length > 0}
                
                rightAxisHasOptions={hasAxisOption && rightAxisOptions.length > 0}
                leftAxisHasOptions={hasAxisOption && leftAxisOptions.length > 0}

                rightAddHasOptions={hasAddOption && rightAdditions.length > 0}
                leftAddHasOptions={hasAddOption && leftAdditions.length > 0}
                
                rightColorHasOptions={hasColorOption && rightColors.length > 0}
                leftColorHasOptions={hasColorOption && leftColors.length > 0}
                
                rightEyeProductNumber={getProductNumber(true)}
                leftEyeProductNumber={getProductNumber(false)}
                subscription={props.subscriptionSelected} 
                subscriptionExistsForRightEye={cart.subscriptionExistsForRightEye}   
                subscriptionExistsForLeftEye={cart.subscriptionExistsForLeftEye}      
                lensDurationCategory={props.lensDurationCategory}
                lensDurationCategoryExistingInCart={cart.lensDurationCategoryExistingInCart}      
            />}
        </Fragment>
    );
});
export default LensSpecification;
